/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { ImageURL } from "../../../../Environment/Environment";
import defaultImg from "../../../../assets/img/thumbnail.png";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import Pagination from "../../../../Helper/Pagination";
import Switch from "@mui/material/Switch";

export default function ImageListing() {
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  const [Imagelist, setImagelist] = useState();
  const [ImageName, setImageName] = useState("");
  const [status, setstatus] = useState("");
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");
  const [selectedState, setselectedState] = useState("");
 

  useEffect(() => {
    getImageList();
  }, [search_key, currentPage]);

  const getImageList = () => {
    setLoading(true);
    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };
    PostService(API_URL.IMAGE_LISTING, param).then(
      (res) => {
        console.log(res?.data);
        if (res.data.status === true) {
          setImagelist(res?.data?.data?.rows);
          SetTotalPageCount(res.data.totalPages);
          SetTotalCount(res.data.totalItems);
          setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const onimageUpload = (e) => {
    console.log(e)
    if(e.target.files[0]){
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  useEffect(() => {
    console.log(selectedState);
    setImageName(selectedState?.name);
    setstatus(selectedState?.status);
    setLocalImgPath(selectedState?.image1);
    setImage(selectedState?.image1);
  }, [selectedState]);

  const submit = (e) => {
    e.preventDefault();
    if (!ImageName || !status || !Image) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    const formdata = new FormData();
    formdata.append("name", ImageName);
    formdata.append("id", selectedState?.priceimageid);
    formdata.append("status", status);
    formdata.append("image", Image);

    PostFormData(API_URL.UPDATE_IMAGE_LISTING, formdata).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getImageList);
          resetFunc();
          document.getElementById("closeEditModal").click();
          // getImageList();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      priceimageid: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.UPDATE_IMAGE_LISTING_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getImageList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function resetFunc() {
    setImageName("");
    setstatus("");
    setImage("");
    setLocalImgPath(defaultImg);
    setError(false);
    setsubmitLoader(false);
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Images List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Images List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div class="table-responsive mt-3">
                    {!loading && (
                      <table class="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Image</th>
                            <th className="text-center">Title</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Imagelist?.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-center">
                                <img
                                  src={item?.image1}
                                  alt="..."
                                  onError={(e) => {
                                    e.target.src = defaultImg;
                                  }}
                                />
                              </td>
                              <td className="text-center">{item?.name}</td>
                              <td className="text-center">
                                <label
                                  className={
                                    item?.status === "active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {item?.status}
                                </label>
                              </td>
                              <td className="text-center">
                              <span className="toggle-switch">
                                    <Switch
                                      checked={item?.status === "active"}
                                      onChange={() => {
                                        changeStatus(
                                          item.priceimageid,
                                          item.status
                                        );
                                      }}
                                      size="small"
                                      color="primary" // You can customize the color
                                      inputProps={{
                                        "aria-label": "toggle switch",
                                      }}
                                    />
                                  </span>
                                <span
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setselectedState(item); 
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                           {Imagelist && Imagelist.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    name="name"
                    value={ImageName}
                    className="form-control"
                    onChange={(e) => setImageName(e.target.value)}
                    placeholder="Title"
                  />
                  {error && !ImageName && (
                    <div className="error">Title cannot be empty</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setstatus(e.target.value)}
                  >
                    <option value="" selected default hidden>
                      Select
                    </option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>

                  {error && !status && (
                    <div className="error">Please Select Status</div>
                  )}
                </div>

                <div className="mt-3">
                  <div className="row d-flex align-items-start">
                    <div className="col-md-5 col-6">
                      <span>
                        <span className="btn btn-primary col-12">
                          Select Image
                          <input
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            className="btn-input position-absolute"
                            style={{ opacity: 0 }}
                            onChange={(e) => onimageUpload(e)}
                          />
                        </span>
                      </span>

                      {error && !Image && (
                        <div className="error">Image should be selected</div>
                      )}
                    </div>
                    <div className="col-md-7 col-6">
                      <img
                        src={ImgPath}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button> 
                <button type="submit" className="btn btn-primary" 
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i> 
                  ) : 'Update' }
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
